// import { faCircle, faHandPointer } from "@fortawesome/free-regular-svg-icons";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faHandPointer,
  faCircleNodes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ControlPosition, MapControl } from "@vis.gl/react-google-maps";
import React, { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import DrawingManagerSelectEditor from "./DrawingManagerSelectEditor";
import DrawingManagerCircleEditor from "./DrawingManagerCircleEditor";
import DrawingManagerPolygonEditor from "./DrawingManagerPolygonEditor";
import useCommonMap from "../../hooks/useCommonMap";

const DrawingManager = ({
  selectedGeometry,
  onSelectedGeometryChanged,
  // centerPoint,
  // onCenterPointChanged,
}) => {
  const commonMap = useCommonMap();
  const { map } = commonMap;
  // const map = useMap();
  // const drawingLib = useMapsLibrary("drawing");
  const tools = useMemo(() => {
    return {
      none: "none",
      select: "select",
      circle: "circle",
      polygon: "polygon",
    };
  }, []);
  const [activeTool, setActiveTool] = useState(tools.none);
  // const selectedGeometryRef = useRef(selectedGeometry);

  // useEffect(() => {
  //   if (!map || !drawingLib) return;
  // }, [map, drawingLib]);

  // useEffect(() => {
  //   console.log("DrawingManager mount");

  //   return () => {
  //     console.log("DrawingManager unmount");
  //   };
  // }, []);

  useEffect(() => {
    if (!map) return null;
    if (activeTool === tools.circle || activeTool === tools.polygon) {
      map.setOptions({ draggableCursor: "crosshair" });
    }
    return () => {
      map.setOptions({ draggableCursor: null });
    };
  }, [map, activeTool]);

  useEffect(() => {
    if (!selectedGeometry) return;

    // If we have changed the selected geometry, go into select mode
    setActiveTool(tools.select);
  }, [selectedGeometry]);

  // const handleCenterPointChanged = (centerPoint) => {
  //   console.log("center point", centerPoint);
  //   onCenterPointChanged && onCenterPointChanged(centerPoint);
  // };

  return (
    <React.Fragment>
      <MapControl position={ControlPosition.TOP_CENTER}>
        <div style={{ background: "#ffffffff", margin: "10px" }}>
          <ButtonGroup size="sm">
            <Button
              variant="secondary"
              onClick={() => {
                setActiveTool(tools.select);
              }}
              active={activeTool === tools.select}
            >
              <FontAwesomeIcon icon={faHandPointer} />
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setActiveTool(tools.circle);
              }}
              active={activeTool === tools.circle}
            >
              <FontAwesomeIcon icon={faCircle} />
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setActiveTool(tools.polygon);
              }}
              active={activeTool === tools.polygon}
            >
              <FontAwesomeIcon icon={faCircleNodes} />
            </Button>
          </ButtonGroup>
        </div>
      </MapControl>
      {activeTool === tools.select && (
        <DrawingManagerSelectEditor
          selectedGeometry={selectedGeometry}
          // centerPoint={centerPoint}
          // onCenterPointChanged={handleCenterPointChanged}
        ></DrawingManagerSelectEditor>
      )}
      {activeTool === tools.circle && (
        <DrawingManagerCircleEditor
          onCreate={(circle) => {
            // if (selectedGeometryRef.current) {
            //   selectedGeometryRef.current.setMap(null);
            //   selectedGeometryRef.current = undefined;
            // }
            // selectedGeometryRef.current = circle;
            onSelectedGeometryChanged && onSelectedGeometryChanged(circle);
            setActiveTool(tools.select);
          }}
        ></DrawingManagerCircleEditor>
      )}
      {activeTool === tools.polygon && (
        <DrawingManagerPolygonEditor
          onCreate={(polygon) => {
            // if (selectedGeometryRef.current) {
            //   selectedGeometryRef.current.setMap(null);
            //   selectedGeometryRef.current = undefined;
            // }
            // selectedGeometryRef.current = polygon;
            onSelectedGeometryChanged && onSelectedGeometryChanged(polygon);
            setActiveTool(tools.select);
          }}
        ></DrawingManagerPolygonEditor>
      )}
    </React.Fragment>
  );
};
export default DrawingManager;
